import { Link } from "react-router-dom";

const links = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    title: "电影频道",
    desc: "动作 · 科幻 · 悬疑 · 爱情",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "电视剧频道",
    desc: "古装 · 都市 · 青春 · 悬疑",
  },
];

export default function CategoryQuickLinks() {
  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {links.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="group flex items-center gap-4 p-5 md:p-6 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors"
          >
            <span className="shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-lg bg-primary-100 text-primary-500 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${link.icon} text-2xl md:text-3xl`}></i>
            </span>
            <div className="min-w-0">
              <h3 className="font-heading font-bold text-foreground-950 text-lg md:text-xl">{link.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 mt-0.5 truncate">{link.desc}</p>
            </div>
            <i className="ri-arrow-right-line ml-auto text-xl text-foreground-400 group-hover:text-primary-500 group-hover:translate-x-1 transition-all"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}